module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung Flyer LEHMANNPARTNER-6fb751edb83b2f9524f05aae056d7f10.pdf";